<template>
  <div class="keyword-content" v-if="display_keywords">
    <div class="keyword-label">{{keyword.name}}</div>
    <div class="keyword-children">
      <faq-article v-for="(item, index) in keyword.articles" :index="index" :article="item" :key="item.id"/>
    </div>
  </div>
  <div class="keyword-content" v-else>
    <faq-article v-for="(item, index) in keyword.articles" :index="index" :article="item" :key="item.id"/>
  </div>
</template>

<script>
import FaqArticle from "./article";
export default {
  name: "faq-keyword",
  components: {FaqArticle},
  props: {
    keyword: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      display_keywords: false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/faq/faq-keyword.vue